import React, { useState } from "react";
import { useMutation, useQuery } from "react-query";
import Axios from "axios";
import {
  antdAsyncMessageError,
  antdAsyncMessageSuccess,
} from "../../../../../helpers/AsyncMessage";
import { Form, Input, Button, Select } from "antd";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import ModalSpecial from "../../../../../components/Layout/Modals/ModalSpecial";
import RangePickerComp from "../../../../../components/common/RangePickerComp";
import SwitchComp from "../../../../../components/common/SwitchComp";
import axios from "axios";
import moment from "moment";
import { IconDraggableBig } from "../../../../../components/Layout/Icons";
import { ButtonDelete } from "../../../../../components/common/Buttons";
import Treeselect from "../../../../../components/common/Treeselect";


const initialState = {
  check: false,
  desktopImageFile: null,
  desktopImageUrl: null,
  mobileImageFile: null,
  mobielImageUrl: null,
  destinationUrl: null,
  selectedProducts: [],
  id: null,
  originalCheckChange: false,
};

const fetchProducts = async (value) => {
  if (value?.length < 3) return [];
  const response = await axios.get(
    `/api/v1/products?page=1&per_page=100&q[identifier_eq]=${value}`
  );
  return response.data;
};

const ModalNewFeaturedCategoryProducts = ({
  onClose,
  modalOpt,
  orderShops,
  bigBoxCategory,
  bannerData,
}) => {
  const [form] = Form.useForm();
  const [switches, setSwitches] = React.useState({});
  const [search, setSearch] = React.useState("");
  const [processedCategoryOptions, setProcessedCategoryOptions] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [copyTargetShops, setCopyTargetShops] = React.useState({});

  const convertToTreeData = (treeData) => {
    if (!treeData || !Array.isArray(treeData)) return [];

    const modifyParentNodes = (node) => {
      if (node.children && node.children.length > 0) {
        const parentAsChild = {
          name: `${node.name}`,
          value: node.value,
          id: node.id,
          isParentCopy: true
        };

        const realId = node.value;
        node.value = `00_${realId}`;

        node.children.unshift(parentAsChild);

        for (let i = 1; i < node.children.length; i++) {
          modifyParentNodes(node.children[i]);
        }
      }

      return node;
    };

    return treeData.map(modifyParentNodes);
  };

  React.useEffect(() => {
    if (bigBoxCategory) {
      const processed = convertToTreeData(bigBoxCategory);
      setProcessedCategoryOptions(processed);
    }
  }, [bigBoxCategory]);

  console.log(switches, "switches");

  const { data: productsData, isLoading } = useQuery(["products", search], () =>
    fetchProducts(search)
  );

  const hasRun = React.useRef(false);

  React.useEffect(() => {
    if (!hasRun.current) {
      const initialSwitches = {};
      orderShops.forEach((shop) => {
        initialSwitches[shop.label.replace(" ", "")] = {
          ...initialState,
          id: shop.value,
        };
      });
      setSwitches(initialSwitches);
      hasRun.current = true;
    }
  }, [orderShops]);

  const mutation = useMutation({
    mutationFn: (value) => {
      const formData = new FormData();
      formData.append("banner[title]", value.title);
      formData.append("banner[banner_place]", "featured_category_products");

      if (value.validity_period && value.validity_period[0] && value.validity_period[1]) {
        formData.append("banner[valid_from]", value.validity_period[0]);
        formData.append("banner[valid_to]", value.validity_period[1]);
      }

      value.category.forEach((categoryId) => {
        formData.append("banner[categories][]", categoryId);
      });

      Object.entries(switches).forEach(([key, switchData], index) => {
        if (switchData.originalCheckChange) {
          if (switchData.selectedProducts.length > 0) {
            switchData.selectedProducts.forEach((product) => {
              formData.append(
                `banner[banner_shops_attributes][${index}][products][]`,
                product.id
              );
            });
          }

          formData.append(
            `banner[banner_shops_attributes][${index}][active]`,
            switchData.check ? "true" : "false"
          );
          formData.append(
            `banner[banner_shops_attributes][${index}][order_shop_id]`,
            switchData.id
          );
          if (modalOpt.type === "edit_featured_category_products") {
            if (switchData.banner_shop_id) {
              formData.append(
                `banner[banner_shops_attributes][${index}][id]`,
                switchData.banner_shop_id
              );
            }
          }
        }
      });

      return Axios[
        modalOpt.type === "edit_featured_category_products" ? "put" : "post"
      ](
        `/api/v1/banners/${modalOpt.type === "edit_featured_category_products"
          ? modalOpt.record_id
          : ""
        }`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      ).then((res) => res.data);
    },
    onSuccess: () => {
      onClose();
      antdAsyncMessageSuccess({ text: "Successfully created", key: "default" });
    },
    onError: antdAsyncMessageError,
  });

  const handleSwitchChange = (name) => {
    setSwitches((prev) => {
      const updatedCheck = !prev[name].check;
      return {
        ...prev,
        [name]: {
          ...prev[name],
          check: updatedCheck,
          originalCheckChange: prev[name].originalCheck !== updatedCheck,
        },
      };
    });
  };

  const handleProductChange = (switchName, value) => {
    const product = productsData?.data?.find((product) => product.id === value);
    setSwitches((prev) => ({
      ...prev,
      [switchName]: {
        ...prev[switchName],
        selectedProducts: [
          ...prev[switchName].selectedProducts,
          { id: product.id, label: product.title },
        ],
        originalCheckChange: true,
      },
    }));
  };

  const handleDelete = (switchName, id) => {
    setSwitches((prev) => ({
      ...prev,
      [switchName]: {
        ...prev[switchName],
        selectedProducts: prev[switchName].selectedProducts.filter(
          (product) => product.id !== id
        ),
        originalCheckChange: true,
      },
    }));
  };

  const handleCopyProducts = (sourceShop, targetShops) => {
    if (!sourceShop || !targetShops || targetShops.length === 0) {
      return;
    }

    setSwitches((prev) => {
      const sourceProducts = prev[sourceShop].selectedProducts;
      const updated = { ...prev };

      targetShops.forEach((targetShop) => {
        const targetProducts = updated[targetShop].selectedProducts;
        const newProducts = sourceProducts.filter(
          (product) => !targetProducts.some((p) => p.id === product.id)
        );

        updated[targetShop] = {
          ...updated[targetShop],
          selectedProducts: [...updated[targetShop].selectedProducts, ...newProducts],
          check: true,
          originalCheckChange: true,
        };
      });

      return updated;
    });

    // Reset target selection for this shop
    setCopyTargetShops((prev) => ({
      ...prev,
      [sourceShop]: [],
    }));
  };

  const onDragEnd = (result) => {
    const { destination, source } = result;

    if (!destination) {
      return;
    }

    const sourceSwitchName = source.droppableId;
    const destinationSwitchName = destination.droppableId;

    if (sourceSwitchName === destinationSwitchName) {
      const newSelectedProducts = Array.from(
        switches[sourceSwitchName].selectedProducts
      );
      const [removed] = newSelectedProducts.splice(source.index, 1);
      newSelectedProducts.splice(destination.index, 0, removed);

      setSwitches((prev) => ({
        ...prev,
        [sourceSwitchName]: {
          ...prev[sourceSwitchName],
          selectedProducts: newSelectedProducts,
          originalCheckChange: true,
        },
      }));
    } else {
      const sourceSelectedProducts = Array.from(
        switches[sourceSwitchName].selectedProducts
      );
      const destinationSelectedProducts = Array.from(
        switches[destinationSwitchName].selectedProducts
      );
      const [removed] = sourceSelectedProducts.splice(source.index, 1);
      destinationSelectedProducts.splice(destination.index, 0, removed);

      setSwitches((prev) => ({
        ...prev,
        [sourceSwitchName]: {
          ...prev[sourceSwitchName],
          selectedProducts: sourceSelectedProducts,
          originalCheckChange: true,
        },
        [destinationSwitchName]: {
          ...prev[destinationSwitchName],
          selectedProducts: destinationSelectedProducts,
          originalCheckChange: true,
        },
      }));
    }
  };

  const hasEditRun = React.useRef(false);

  React.useEffect(() => {
    if (modalOpt.type === "edit_featured_category_products" && bannerData && !hasEditRun.current) {
      const matchingBanner = bannerData.find(
        (banner) => banner.id === modalOpt.record_id
      );
      if (matchingBanner) {
        form.setFieldsValue({
          title: matchingBanner.title,
          validity_period: [
            moment(matchingBanner.valid_from),
            moment(matchingBanner.valid_to),
          ],
          category: matchingBanner.categories.map((category) => category.id),
        });

        matchingBanner.banner_shops.forEach((shop) => {
          const switchName = shop.order_shop.title?.replace(" ", "");

          setSwitches((prev) => {
            if (prev[switchName]) {
              return {
                ...prev,
                [switchName]: {
                  ...prev[switchName],
                  desktopImageUrl: shop.desktop_image,
                  mobielImageUrl: shop.mobile_image,
                  destinationUrl: shop.destination_url,
                  check: shop.active,
                  originalCheck: shop.active,
                  banner_shop_id: shop.id,
                  originalCheckChange: true,
                  selectedProducts: shop.products.map((product) => ({
                    id: product.id,
                    label: product.title,
                  })),
                },
              };
            } else {
              return prev;
            }
          });
        });

        const categoryIds = matchingBanner.categories.map((category) => category.id);
        setSelectedCategories(categoryIds);
        hasEditRun.current = true;
      }
    }
  }, [modalOpt.type, modalOpt.record_id, bannerData]);

  return (
    <ModalSpecial
      style={{ width: 570 }}
      text={
        <span className="font-bold text-xl text-black">
          {modalOpt.type === "edit_featured_category_products" ? "Edit" : "Add"}{" "}
          featured category product batch
        </span>
      }
      onClose={onClose}
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={(value) => {
          const formValues = {
            ...value,
            category: selectedCategories,
          };
          mutation.mutate(formValues);
        }}
      >
        <Form.Item
          label="Title"
          name="title"
          rules={[{ required: true, message: "Can't be empty" }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="Category"
          name="category"
          rules={[{ required: true, message: "Can't be empty" }]}
        >
          <Treeselect
            options={processedCategoryOptions || []}
            value={selectedCategories}
            onChange={(values) => {
              const categoryIds = values.map(value => {
                return typeof value === 'string' && value.startsWith('00_')
                  ? parseInt(value.substring(3))
                  : value;
              });
              setSelectedCategories(categoryIds);
              form.setFieldsValue({ category: categoryIds });
            }}
            placeholder="Select categories..."
            multiSelect={true}
            searchable={true}
            confirmClear={true}
            dropdownWidth="500px"
            showStrategy="SHOW_ALL"
          />
        </Form.Item>
        <Form.Item
          label="Validity period"
          name="validity_period"
        >
          <RangePickerComp
            style={{ width: "100%" }}
            showTime={{ format: "HH:mm" }}
            placeholder={["Start time", "End time"]}
            disabledDate={() => false}
          />
        </Form.Item>
        <hr className="hr-margin" />
        <DragDropContext onDragEnd={onDragEnd}>
          {Object.keys(switches).map((switchName) => {
            return (
              <div key={switchName}>
                <SwitchComp
                  className="d-flex flex-row-reverse justify-content-end"
                  labelClassName="ml-1"
                  label={switchName.slice(0, 2) + " " + switchName.slice(2)}
                  checked={switches[switchName].check}
                  onChange={() => handleSwitchChange(switchName)}
                />
                {switches[switchName].check && (
                  <div>
                    <Form.Item
                      label="Add product"
                      name={`product_${switchName}`}
                      rules={[
                        { required: false, message: "Can't be empty" },
                        () => ({
                          validator(_, value) {
                            if (
                              switches?.[switchName]?.selectedProducts?.length === 0
                            ) {
                              return Promise.reject(
                                new Error("At least one product must be added")
                              );
                            }
                            return Promise.resolve();
                          },
                        }),
                      ]}
                    >
                      <Select
                        showSearch
                        placeholder="Select a product"
                        optionFilterProp="children"
                        onSearch={setSearch}
                        loading={isLoading}
                        onChange={(value) => handleProductChange(switchName, value)}
                      >
                        {productsData?.data?.map?.((product) => (
                          <Select.Option key={product.id} value={product.id}>
                            {product.identifier} - {product.title}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                    {switches?.[switchName]?.selectedProducts?.length === 0 && (
                      <div className="text-sm text-gray-500">No products added</div>
                    )}
                    <Droppable droppableId={switchName}>
                      {(provided) => (
                        <div {...provided.droppableProps} ref={provided.innerRef}>
                          {switches?.[switchName]?.selectedProducts?.map?.(
                            (product, index) => (
                              <Draggable
                                key={`${switchName}-${product.id}`}
                                draggableId={`${switchName}-${product.id}`}
                                index={index}
                              >
                                {(provided) => (
                                  <div
                                    ref={provided.innerRef}
                                    {...provided.draggableProps}
                                    {...provided.dragHandleProps}
                                  >
                                    <div
                                      className="d-flex align-items-center justify-content-between bg-white p-1 mb-1"
                                      style={{
                                        border: "1px solid #E9E9E9",
                                        borderRadius: 2,
                                        backgroundColor: "#FCFCFC",
                                      }}
                                    >
                                      <div className="d-flex align-items-center">
                                        <div className="mr-1">
                                          <IconDraggableBig />
                                        </div>
                                        <div className="ml-1 text-sm text-black">
                                          {product.label}
                                        </div>
                                      </div>
                                      <ButtonDelete
                                        onDelete={() =>
                                          handleDelete(switchName, product.id)
                                        }
                                      />
                                    </div>
                                  </div>
                                )}
                              </Draggable>
                            )
                          )}
                          {provided.placeholder}
                        </div>
                      )}
                    </Droppable>
                    {switches?.[switchName]?.selectedProducts?.length > 0 && (
                      <div className="mt-3 pt-2" style={{ borderTop: "1px solid #E9E9E9" }}>
                        <div className="text-sm text-gray-700 mb-2">Copy all products to:</div>
                        <div className="d-flex" style={{ gap: "8px" }}>
                          <Select
                            mode="multiple"
                            style={{ flex: 1 }}
                            placeholder="Select shops"
                            value={copyTargetShops[switchName] || []}
                            onChange={(value) =>
                              setCopyTargetShops((prev) => ({
                                ...prev,
                                [switchName]: value,
                              }))
                            }
                          >
                            {Object.keys(switches)
                              .filter((key) => key !== switchName)
                              .map((key) => (
                                <Select.Option key={key} value={key}>
                                  {key.slice(0, 2) + " " + key.slice(2)}
                                </Select.Option>
                              ))}
                          </Select>
                          <Button
                            type="default"
                            onClick={() => handleCopyProducts(switchName, copyTargetShops[switchName])}
                            disabled={!copyTargetShops[switchName] || copyTargetShops[switchName].length === 0}
                          >
                            Copy
                          </Button>
                        </div>
                      </div>
                    )}
                  </div>
                )}
                <hr className="hr-margin" />
              </div>
            )
          })}
        </DragDropContext>
        <Form.Item>
          <Button
            className="w-100"
            type="primary"
            htmlType="submit"
            loading={mutation.isLoading}
          >
            {modalOpt.type === "edit_featured_category_products"
              ? "Update"
              : "Add"}
          </Button>
        </Form.Item>
      </Form>
    </ModalSpecial>
  );
};

export default ModalNewFeaturedCategoryProducts;
